/**
 * THE SENSITIVITY SLIDER (0.1..0.9, default 0.55) → the engine's REACTIVITY g (engineApi 1.13
 * MusicalAnalyzer.setReactivity: one visible gain every world family obeys — 2D, shader, three.js, fx
 * — clamped by the engine to 0.2..2, 1 = neutral). Exponential around the default so equal slider
 * steps feel like equal changes: 0.55 → exactly 1 (byte-identical to engines without it), the low end
 * → 0.3 (calm), the top → 2 (hyper-reactive). ONE mapping for every surface that has the slider — the
 * web/desktop player and the phone shells' Settings (via the receiver's __syqelDrive — receiver/phoneBridge.ts).
 */
export const SENS_DEFAULT = 0.55
export const SENS_MIN = 0.1
export const SENS_MAX = 0.9

export function reactivityOf(sens: number): number {
  const s = Math.min(SENS_MAX, Math.max(SENS_MIN, sens))
  return s <= SENS_DEFAULT ? 0.3 ** ((SENS_DEFAULT - s) / (SENS_DEFAULT - SENS_MIN)) : 2 ** ((s - SENS_DEFAULT) / (SENS_MAX - SENS_DEFAULT))
}
